/* GYMGAUR product features. Written for the GYMGAUR theme (Spotlight base).
   Bottom sheets, wishlist (kept on this device) with hearts on every product card and the Saved page,
   delivery estimates, notify me, Complete the look (2 or 3 pieces, size sheet with chart) and the
   sticky add to bag that reacts to what is in the bag. */
(function () {
  'use strict';

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var KEY = 'gg-saved';
  var LOOK_KEY = 'gg-look-added';

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function money(cents) {
    var c = Math.round(cents);
    var whole = c % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(c / 100);
    } catch (e) { return '£' + (c / 100).toFixed(2); }
  }
  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true }); else fn(); }
  function subscribeTo(eventName, cb) {
    onReady(function () {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[eventName]) {
        subscribe(PUB_SUB_EVENTS[eventName], cb);
      }
    });
  }
  function getCart() {
    return fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function refreshBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.shopify-section');
    bubble.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
  }
  function cartChanged(source) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: source });
    document.dispatchEvent(new CustomEvent('gg:cart-changed', { detail: { source: source } }));
  }

  /* ---------- Bottom sheets ---------- */
  var openSheetEl = null;
  var lastFocus = null;
  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return null;
    if (openSheetEl && openSheetEl !== sheet) closeSheet(true);
    lastFocus = document.activeElement;
    sheet.hidden = false;
    openSheetEl = sheet;
    document.documentElement.classList.add('gg-sheet-open');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    var panel = $('.gg-sheet__panel', sheet);
    if (panel) panel.focus();
    return sheet;
  }
  function closeSheet(instant) {
    var sheet = openSheetEl;
    if (!sheet) return;
    openSheetEl = null;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('gg-sheet-open');
    if (instant) sheet.hidden = true; else setTimeout(function () { sheet.hidden = true; }, 220);
    var back = sheet.dataset.back;
    delete sheet.dataset.back;
    if (back && !instant) { setTimeout(function () { openSheet(back); }, 230); return; }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  /* Other sections open these sheets too (gg-welcome-sheet), and any [data-gg-sheet-open="id"] button opens one */
  window.ggSheet = { open: openSheet, close: closeSheet };
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-gg-sheet-open]');
    if (!o) return;
    e.preventDefault();
    openSheet(o.getAttribute('data-gg-sheet-open'));
  });

  /* Size sheet: title, size buttons, the item's size chart */
  function openSizeSheet(opts) {
    var sheet = document.getElementById('gg-size-sheet');
    if (!sheet) return;
    $('[data-size-title]', sheet).textContent = opts.title;
    var list = $('[data-size-options]', sheet);
    list.innerHTML = opts.variants.map(function (v) {
      var on = String(v.id) === String(opts.selected);
      return '<button type="button" class="gg-sheet__size' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" data-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        esc(v.size) + (v.available ? '' : '<span class="visually-hidden"> (sold out)</span>') + '</button>';
    }).join('');
    $('[data-size-chart]', sheet).innerHTML = opts.chart || '';
    if (savedUnit()) setUnit(savedUnit(), sheet);
    list.onclick = function (e) {
      var b = e.target.closest('[data-variant]');
      if (!b || b.disabled) return;
      opts.onSelect(b.dataset.variant);
      closeSheet();
    };
    openSheet('gg-size-sheet');
  }

  /* ---------- Wishlist (kept on this device) ---------- */
  function readSaved() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function writeSaved(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function syncHearts() {
    var saved = readSaved();
    var countHtml = saved.length ? '<span aria-hidden="true">' + saved.length + '</span><span class="visually-hidden">' + saved.length + ' saved</span>' : '';
    $$('[data-gg-saved-count]').forEach(function (el) {
      if (el.innerHTML !== countHtml) el.innerHTML = countHtml;  /* only touch it when it changes */
      el.hidden = saved.length === 0;
    });
    $$('[data-gg-heart]').forEach(function (btn) {
      var on = saved.indexOf(btn.dataset.ggHeart) > -1;
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  /* Cards added after the page loads (best sellers grid, Saved page suggestions, collection filters and
     infinite scroll) get their saved state straight away, so a saved piece never shows an empty heart */
  var heartSyncQueued = false;
  function queueHeartSync() {
    if (heartSyncQueued) return;
    heartSyncQueued = true;
    requestAnimationFrame(function () { heartSyncQueued = false; syncHearts(); });
  }
  if (window.MutationObserver) {
    onReady(function () {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-gg-heart') || n.querySelector('[data-gg-heart]'))) { queueHeartSync(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    });
  }
  /* Other tabs saving or removing pieces */
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncHearts(); renderSaved(); } });

  /* The "kept on this device" sheet shows the first time something is saved, then not again for 30 days,
     so saving several pieces in a row is not interrupted. In between, a small note confirms each save. */
  var PROMPT_KEY = 'gg-saved-prompted';
  var PROMPT_DAYS = 30;
  function shouldPrompt() {
    try {
      var at = +localStorage.getItem(PROMPT_KEY) || 0;
      return !at || Date.now() - at > PROMPT_DAYS * 864e5;
    } catch (e) { return true; }
  }
  function markPrompted() { try { localStorage.setItem(PROMPT_KEY, String(Date.now())); } catch (e) {} }
  var toastTimer = null;
  function savedToast(title) {
    var t = document.getElementById('gg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'gg-toast';
      t.className = 'gg-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<span>' + esc(title ? title + ' saved' : 'Saved to your wishlist') + '</span><a href="' + ROOT + '/pages/saved">View</a>';
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  var pendingRemove = null;
  function askRemove(handle, title) {
    pendingRemove = handle;
    var sheet = document.getElementById('gg-confirm-sheet');
    if (!sheet) { removeSaved(handle); return; }
    $('[data-confirm-text]', sheet).textContent = (title ? title + ' will' : 'This piece will') + ' be taken off your saved list on this device.';
    openSheet('gg-confirm-sheet');
  }
  function removeSaved(handle) {
    writeSaved(readSaved().filter(function (h) { return h !== handle; }));
    syncHearts();
    renderSaved();
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-gg-heart]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      var handle = heart.dataset.ggHeart;
      var saved = readSaved();
      if (saved.indexOf(handle) > -1) {
        askRemove(handle, heart.dataset.title);
      } else {
        saved.unshift(handle);
        writeSaved(saved);
        syncHearts();
        if (document.querySelector('[data-gg-saved-grid]')) renderSaved();
        else if (shouldPrompt()) { markPrompted(); openSheet('gg-sheet'); }
        else savedToast(heart.dataset.title);
      }
      return;
    }
    if (e.target.closest('[data-confirm-remove]')) {
      if (pendingRemove) removeSaved(pendingRemove);
      pendingRemove = null;
      closeSheet();
      return;
    }
    if (e.target.closest('[data-gg-sheet-close]')) { closeSheet(); return; }

    var share = e.target.closest('[data-gg-share]');
    if (share) {
      e.preventDefault();
      var url = location.origin + share.dataset.ggShare;
      var title = share.dataset.title || 'GYMGAUR';
      var status = share.parentNode.querySelector('[data-share-status]');
      if (navigator.share) {
        navigator.share({ title: title, text: title + ' from GYMGAUR', url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { if (status) status.textContent = 'Link copied'; });
      }
      return;
    }

    /* Size chart units: switch every chart on the page, and remember the choice for this visit */
    var unitBtn = e.target.closest('[data-gg-unit]');
    if (unitBtn) {
      var unit = unitBtn.dataset.ggUnit;
      setUnit(unit);
      try { sessionStorage.setItem('gg-unit', unit); } catch (err) {}
      return;
    }

    var back = e.target.closest('[data-gg-back]');
    if (back) {
      var last = lastPage();
      if (last) { e.preventDefault(); location.href = last; }
    }
  });

  function setUnit(unit, scope) {
    $$('.gg-size-chart', scope).forEach(function (c) {
      c.dataset.unit = unit;
      $$('[data-gg-unit]', c).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.ggUnit === unit ? 'true' : 'false'); });
    });
  }
  function savedUnit() { try { return sessionStorage.getItem('gg-unit'); } catch (e) { return null; } }

  /* ---------- Back to where the shopper was ----------
     Every ordinary page is remembered for this visit, so the close buttons on the bag and Saved pages
     go back to it (not to checkout or to the bag itself). */
  var LAST_KEY = 'gg-last-page';
  function isUtilityPage(path) { return /^\/(cart|checkouts?|account|pages\/saved|challenge|password)(\/|$)/.test(path.replace(ROOT, '') || '/'); }
  function lastPage() {
    try {
      var u = sessionStorage.getItem(LAST_KEY);
      if (u && u.indexOf(location.origin) === 0 && u.split('#')[0] !== location.href.split('#')[0]) return u;
    } catch (e) {}
    return null;
  }
  if (!isUtilityPage(location.pathname)) { try { sessionStorage.setItem(LAST_KEY, location.href); } catch (e) {} }

  /* ---------- Saved page ---------- */
  function savedCard(p) {
    var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + esc(p.title) + '" loading="lazy">' : '';
    return '<div class="gg-card-wrap gg-saved__card">' +
      '<a class="gg-product-card" href="' + p.url + '">' +
        '<div class="gg-media">' + img + '</div>' +
        '<div class="gg-product-card__body">' +
          '<h3 class="gg-product-card__title">' + esc(p.title) + '</h3>' +
          (p.type ? '<p class="gg-product-card__sub">' + esc(p.type) + '</p>' : '') +
          '<p class="gg-price">' + (p.available ? money(p.price) : '<span class="gg-price__soldout">Sold out</span>') + '</p>' +
        '</div>' +
      '</a>' +
      '<button type="button" class="gg-heart gg-heart--card is-saved" data-gg-heart="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" aria-pressed="true" aria-label="Save ' + esc(p.title) + ' to your wishlist">' + heartIcons() + '</button>' +
      '<div class="gg-saved__share"><button type="button" class="gg-saved__share-btn" data-gg-share="' + p.url + '" data-title="' + esc(p.title) + '">' + iconShare() + '<span>Share</span></button><span class="gg-saved__share-status" role="status" data-share-status></span></div>' +
    '</div>';
  }
  function heartIcons() {
    var off = document.querySelector('[data-gg-icon-heart]');
    var on = document.querySelector('[data-gg-icon-heart-filled]');
    return '<span class="gg-heart__off">' + (off ? off.innerHTML : '') + '</span><span class="gg-heart__on">' + (on ? on.innerHTML : '') + '</span>';
  }
  function iconShare() { var t = document.querySelector('[data-gg-icon-share]'); return t ? t.innerHTML : ''; }

  function renderSaved() {
    var grid = $('[data-gg-saved-grid]');
    if (!grid) return;
    var empty = $('[data-gg-saved-empty]');
    var saved = readSaved();
    if (!saved.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; renderSuggestions([]); return; }
    if (empty) empty.hidden = true;
    Promise.all(saved.map(function (h) {
      return fetch(ROOT + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var found = products.filter(Boolean);
      grid.innerHTML = found.map(savedCard).join('');
      renderSuggestions(saved, found.map(function (p) { return p.title; }));
    });
  }

  /* Suggestions on the Saved page: best sellers you have not saved (in any colour), one card per item */
  var suggestionsLoaded = null;
  function renderSuggestions(saved, titles) {
    titles = (titles || []).map(function (t) { return t.trim().toLowerCase(); });
    var wrap = $('[data-gg-saved-suggest]');
    if (!wrap) return;
    var grid = $('[data-gg-saved-suggest-grid]', wrap);
    (suggestionsLoaded = suggestionsLoaded || fetch(ROOT + '/collections/all?sort_by=best-selling&section_id=gg-best-sellers-feed').then(function (r) { return r.ok ? r.text() : ''; }))
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var cards = $$('.gg-card-wrap', holder).filter(function (c) { var t = c.querySelector('.gg-product-card__title'); return saved.indexOf(c.dataset.handle) === -1 && !(t && titles.indexOf(t.textContent.trim().toLowerCase()) > -1); }).slice(0, 4);
        grid.innerHTML = '';
        cards.forEach(function (c) { grid.appendChild(c); });
        wrap.hidden = cards.length === 0;
        syncHearts();
      }).catch(function () { wrap.hidden = true; });
  }

  /* ---------- Delivery estimate ---------- */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function addDays(date, n) { var d = new Date(date); d.setDate(d.getDate() + n); return d; }
  function notSunday(d) { if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; }  /* no Sunday deliveries */
  function fmt(d, withMonth) { return DAYS[d.getDay()] + ' ' + d.getDate() + (withMonth ? ' ' + MONTHS[d.getMonth()] : ''); }
  if (!customElements.get('gg-delivery')) {
    customElements.define('gg-delivery', class extends HTMLElement {
      connectedCallback() {
        var now = new Date();
        var start = notSunday(addDays(addBusinessDays(now, +this.dataset.prodMin || 1), +this.dataset.shipMin || 4));
        var end = notSunday(addDays(addBusinessDays(now, +this.dataset.prodMax || 3), +this.dataset.shipMax || 7));
        var out = this.querySelector('[data-range]');
        if (out) out.textContent = fmt(start, start.getMonth() !== end.getMonth()) + ' to ' + fmt(end, true);
        this.countdown();
      }
      /* Bag only: the estimate above is worked out from today, so it moves on at midnight. When ordering
         tomorrow would give a later latest date, say how long is left to keep today's estimate. When it
         would not (a weekend, say), say nothing, so the message is never false urgency. */
      countdown() {
        var el = this.querySelector('[data-countdown]');
        if (!el) return;
        var self = this;
        var latest = function (from) { return notSunday(addDays(addBusinessDays(from, +self.dataset.prodMax || 3), +self.dataset.shipMax || 7)); };
        var tick = function () {
          var now = new Date();
          var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
          if (latest(now).toDateString() === latest(midnight).toDateString()) { el.hidden = true; return; }
          var mins = Math.max(1, Math.ceil((midnight - now) / 60000));
          var h = Math.floor(mins / 60), m = mins % 60;
          var left = (h ? h + 'h ' : '') + m + 'm';
          el.textContent = 'Order within ' + left + ' for these dates.';
          el.hidden = false;
        };
        tick();
        clearInterval(this._ggTimer);
        this._ggTimer = setInterval(tick, 30000);
      }
      disconnectedCallback() { clearInterval(this._ggTimer); }
    });
  }

  /* ---------- Product page: current variant ---------- */
  function mainForm() { return $('product-form form') || $('form[action*="/cart/add"]'); }
  function currentVariantId() { var f = mainForm(); var i = f && f.querySelector('input[name="id"]'); return i ? i.value : null; }
  function onVariantChange(cb) {
    subscribeTo('variantChange', function (e) { cb(e && e.data && e.data.variant); });
    document.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) setTimeout(function () { cb(null); }, 400); });
  }
  /* ---------- No size picked yet ----------
     Product pages open with no size ticked (product-variant-options). Until one is picked, Add to bag (main
     button or sticky bar) opens #gg-add-sheet with the sizes as rows; tapping a size picks it in Spotlight's
     picker and adds it through Spotlight's own form, so the bag and its pop-up behave as normal. */
  function sizeInputs() { return $$('variant-selects .gg-option--size input[type="radio"]'); }
  function needSize() {
    var ins = sizeInputs();
    return ins.length > 1 && !ins.some(function (i) { return i.checked; });
  }
  function stickyData() {
    var st = $('gg-sticky-atc');
    var data = { variants: {}, title: '', colour: '', img: '' };
    if (!st) return data;
    try { data.variants = JSON.parse(st.querySelector('[data-sticky-variants]').textContent); } catch (e) {}
    var t = st.querySelector('.gg-sticky__title');
    data.title = t ? t.textContent.trim() : '';
    data.colour = st.dataset.colour || '';
    var img = st.querySelector('.gg-sticky__media img');
    data.img = img ? img.currentSrc || img.src : '';
    return data;
  }
  function submitMainForm() {
    var f = mainForm();
    if (!f) return;
    if (f.requestSubmit) f.requestSubmit();
    else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
  function openAddSheet() {
    var sheet = document.getElementById('gg-add-sheet');
    if (!sheet) return false;
    var d = stickyData();
    var ids = Object.keys(d.variants);
    var first = d.variants[ids.filter(function (id) { return d.variants[id].available; })[0] || ids[0]] || {};
    $('[data-add-product]', sheet).innerHTML =
      (d.img ? '<img src="' + esc(d.img) + '" alt="" width="64" height="80">' : '') +
      '<div><p class="gg-add__name">' + esc(d.title) + '</p>' +
      (d.colour ? '<p class="gg-add__colour">' + esc(d.colour) + '</p>' : '') +
      '<p class="gg-add__price">' + esc(first.price || '') + '</p></div>';
    var list = $('[data-add-sizes]', sheet);
    list.innerHTML = ids.map(function (id) {
      var v = d.variants[id];
      var gone = !v.available && isRetiredSize(v.size);
      var action = v.available ? 'Add to bag <span aria-hidden="true">+</span>' : (gone ? 'Sold out' : 'Sold out · Notify me');
      return '<li><button type="button" class="gg-add__row' + (v.available ? '' : ' is-soldout') + '" data-size="' + esc(v.size) + '" data-available="' + v.available + '"' + (gone ? ' disabled' : '') +
        ' aria-label="' + esc(v.size) + (v.available ? ', add to bag' : gone ? ', sold out' : ', sold out, get a restock alert') + '">' +
        '<span class="gg-add__size">' + esc(v.size) + '</span><span class="gg-add__action">' + action + '</span></button></li>';
    }).join('');
    $('[data-add-status]', sheet).textContent = '';
    list.onclick = function (e) {
      var row = e.target.closest('.gg-add__row');
      if (!row || row.disabled) return;
      var size = row.dataset.size;
      chooseMainSize(size);
      if (row.dataset.available !== 'true') {
        closeSheet(true);
        var st = $('gg-sticky-atc');
        if (st && st.openNotify) setTimeout(function () { st.openNotify(); }, 300); else { var n = $('gg-notify'); if (n) n.scrollIntoView({ block: 'center' }); }
        return;
      }
      closeSheet(true);
      setTimeout(submitMainForm, 0);
    };
    openSheet('gg-add-sheet');
    return true;
  }
  /* Main Add to bag with no size picked: ask for one first (capture phase, before Spotlight's form handler) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest || !f.closest('product-form') || f.closest('.gg-look')) return;
    if (!needSize()) return;
    e.preventDefault();
    e.stopPropagation();
    openAddSheet();
  }, true);

  /* Size guide as a bottom sheet: this item's chart and How to measure */
  function openGuideSheet(fromSheet) {
    var sheet = document.getElementById('gg-guide-sheet');
    var tpl = document.querySelector('gg-sticky-atc template[data-main-chart]');
    var html = tpl ? tpl.innerHTML.trim() : '';
    if (!sheet || !html) return false;
    $('[data-guide-chart]', sheet).innerHTML = html;
    if (savedUnit()) setUnit(savedUnit(), sheet);
    if (fromSheet) sheet.dataset.back = fromSheet;
    openSheet('gg-guide-sheet');
    return true;
  }
  document.addEventListener('click', function (e) {
    var g = e.target.closest('[data-gg-size-guide]');
    if (!g) return;
    var from = g.closest('.gg-sheet');
    if (openGuideSheet(from ? from.id : null)) e.preventDefault();
  });

  /* Pick a size in Spotlight's own picker, so the main form, price and URL all update as normal */
  function chooseMainSize(size) {
    var inputs = $$('variant-selects .gg-option--size input[type="radio"], variant-selects fieldset:not(.gg-option--single-colour) input[type="radio"]');
    var match = inputs.filter(function (i) { return i.value === size; })[0];
    if (match && !match.checked) {
      var label = document.querySelector('label[for="' + match.id + '"]');
      if (label) label.click(); else { match.checked = true; match.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  }

  /* Sizes GYMGAUR no longer offers. Shopify has them at 0 stock so they cannot be bought; here they also
     skip "Notify me", since they will not come back. */
  var RETIRED_SIZES = ['3XL'];
  function isRetiredSize(size) { return RETIRED_SIZES.indexOf(String(size || '').trim().toUpperCase()) > -1; }

  /* Complete the look sets, from a product title. Mirrors gg-look-meta and the Set collections in Shopify
     that the set discounts apply to; keep all three in step. */
  var SET_NAMES = { contrast: 'Contrast', snow: 'Snow Wash', varsity: 'Varsity', performance: 'Performance', boxy: 'Boxy' };
  function setOf(title) {
    var t = String(title || '').toLowerCase();
    if (t.indexOf('contrast') > -1) return 'contrast';
    if (t.indexOf('snow wash') > -1) return 'snow';
    if (t.indexOf('varsity') > -1) return 'varsity';
    if (t.indexOf('performance') > -1) return 'performance';
    if (t.indexOf('boxy oversized') > -1 || t.indexOf('straight-leg') > -1) return 'boxy';
    return 'other';
  }

  /* ---------- Notify me ---------- */
  if (!customElements.get('gg-notify')) {
    customElements.define('gg-notify', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var data = $('gg-sticky-atc [data-sticky-variants]');
        try { this.variants = data ? JSON.parse(data.textContent) : {}; } catch (e) { this.variants = {}; }
        onVariantChange(function (variant) {
          var v = self.variants[String(variant ? variant.id : currentVariantId())];
          if (v) self.setMode(!v.available, v.size);
        });
        var first = this.variants[String(currentVariantId())];
        if (first && !first.available) this.setMode(true, first.size);
      }
      setMode(soldout, size) {
        /* Sizes we no longer offer (3XL) are sold out for good: no restock alert, so nothing suggests they return */
        var gone = soldout && isRetiredSize(size);
        this.hidden = gone;
        if (gone) return;
        var tags = this.querySelector('[data-tags]');
        if (tags) tags.value = (soldout ? 'restock' : 'drop-alert') + ',' + this.dataset.handle + ',size-' + String(size || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var drop = this.querySelector('[data-label-drop]');
        var back = this.querySelector('[data-label-restock]');
        if (drop) drop.hidden = soldout;
        if (back) back.hidden = !soldout;
        var box = this.querySelector('details');
        if (box && soldout) box.open = true;
      }
    });
  }

  /* ---------- Complete the look ---------- */
  if (!customElements.get('gg-complete-look')) {
    customElements.define('gg-complete-look', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.pct2 = +this.dataset.pct2 || 10;
        this.pct3 = +this.dataset.pct3 || 15;
        this.items = $$('[data-piece]', this).map(function (li) {
          var data = {};
          try { data = JSON.parse(li.querySelector('[data-piece-json]').textContent); } catch (e) {}
          var tpl = li.querySelector('template[data-chart]');
          return { el: li, index: +li.dataset.piece, data: data, chart: tpl ? tpl.innerHTML : '', selected: data.selected ? String(data.selected) : null };
        });
        this.third = false;
        this.addBtn = $('[data-add-all]', this);
        this.status = $('[data-status]', this);

        this.items.forEach(function (item) {
          var btn = item.el.querySelector('[data-size-btn]');
          if (btn) btn.addEventListener('click', function () { self.pickSize(item); });
        });
        var more = $('[data-add-third]', this);
        if (more) more.addEventListener('click', function () { self.setThird(true); });
        var remove = $('[data-remove-third]', this);
        if (remove) remove.addEventListener('click', function () { self.setThird(false); });
        this.addBtn.addEventListener('click', function () { self.add(); });

        onVariantChange(function (variant) {
          var main = self.items[0];
          main.selected = String(variant ? variant.id : currentVariantId());
          self.render();
        });
        this.render();
      }
      active() { var t = this.third; return this.items.filter(function (i) { return i.index < 2 || t; }); }
      pct() { return this.active().length >= 3 ? this.pct3 : this.pct2; }
      variantOf(item) {
        var id = item.selected;
        var vs = item.data.variants || [];
        return vs.filter(function (v) { return String(v.id) === String(id); })[0] || vs.filter(function (v) { return v.available; })[0] || vs[0];
      }
      setThird(on) {
        this.third = on;
        var li = this.items.filter(function (i) { return i.index === 2; })[0];
        if (li) li.el.hidden = !on;
        var more = $('[data-add-third]', this);
        if (more) more.hidden = on;
        this.render();
        this.status.textContent = '';
        if (on && li) li.el.querySelector('[data-size-btn]').focus();
      }
      pickSize(item) {
        var self = this;
        openSizeSheet({
          title: item.data.title,
          variants: item.data.variants || [],
          selected: item.selected,
          chart: item.chart,
          onSelect: function (id) {
            item.selected = String(id);
            self.status.textContent = '';
            if (item.index === 0) {
              var v = self.variantOf(item);
              if (v) chooseMainSize(v.size);
            }
            self.render();
          }
        });
      }
      render() {
        var pct = this.pct();
        var self = this;
        var now = 0, was = 0;
        this.items.forEach(function (item) {
          var v = self.variantOf(item);
          if (!v) return;
          var price = v.price;
          var discounted = Math.round(price * (100 - pct) / 100);
          var nowEl = item.el.querySelector('[data-now]');
          var wasEl = item.el.querySelector('[data-was]');
          if (nowEl) nowEl.textContent = money(discounted);
          if (wasEl) wasEl.textContent = money(price);
          var btn = item.el.querySelector('[data-size-btn]');
          if (btn) {
            var chosen = item.selected && (item.data.variants || []).some(function (x) { return String(x.id) === String(item.selected); });
            btn.textContent = chosen ? 'Size: ' + v.size : 'Select size';
            btn.classList.toggle('is-chosen', !!chosen);
          }
          if (item.index < 2 || self.third) { now += discounted; was += price; }
        });
        $('[data-total-now]', this).textContent = money(now);
        $('[data-total-was]', this).textContent = money(was);
        var n = this.active().length;
        this.addBtn.textContent = n >= 3 ? 'Add all 3 to bag' : 'Add both to bag';
        var offer = $('.gg-look__offer', this);
        var setName = this.dataset.set ? ' from the ' + this.dataset.set + ' set' : '';
        if (offer) offer.textContent = n >= 3 ? this.pct3 + '% off each of the 3 pieces.' : this.pct2 + '% off each piece with 2' + setName + '. ' + this.pct3 + '% off each with 3.';
      }
      add() {
        var self = this;
        var items = this.active();
        if (!needSize()) items[0].selected = String(currentVariantId() || items[0].selected || '');
        var missing = items.filter(function (i) { return !i.selected; })[0];
        if (missing) {
          this.status.textContent = 'Pick a size for each piece first.';
          this.pickSize(missing);
          return;
        }
        this.addBtn.disabled = true;
        this.status.textContent = 'Adding…';
        fetch(ROOT + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items.map(function (i) { return { id: +i.selected, quantity: 1 }; }),
            sections: 'cart-icon-bubble'
          })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            if (res.sections) refreshBubble(res.sections['cart-icon-bubble']);
            var added = (res.items || []).length;
            if (added && added < items.length) throw { description: 'Only ' + added + ' of the ' + items.length + ' pieces could be added. Please check your bag.' };
            try { sessionStorage.setItem(LOOK_KEY, JSON.stringify({ ids: items.map(function (i) { return +i.selected; }), pct: self.pct(), n: items.length })); } catch (e) {}
            cartChanged('gg-complete-look');
            self.status.innerHTML = 'Added. ' + self.pct() + '% off each piece is applied in your bag. <a href="' + ROOT + '/cart">View bag</a>';
          })
          .catch(function (err) { self.status.textContent = (err && err.description) || 'Could not add the look. Please try again.'; })
          .then(function () { self.addBtn.disabled = false; });
      }
    });
  }

  /* ---------- Chat button clears the sticky add to bag ----------
     Shopify Inbox draws its button in <inbox-online-store-chat id="ShopifyChat">, with its own styles inside a
     shadow root, so theme CSS cannot reach it. While the sticky bar is on screen, the fixed part of the widget
     (the element itself, or the fixed element inside it) is lifted so its bottom sits at least 16px above the
     bar. Nothing moves while the chat window is open. */
  var CHAT_GAP = 16;
  var chatLift = 0;
  function chatTarget() {
    var host = document.querySelector('inbox-online-store-chat, #ShopifyChat');
    if (host) {
      if (getComputedStyle(host).position === 'fixed') return { el: host, host: host };
      var root = host.shadowRoot;
      if (root) {
        var all = root.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          if (getComputedStyle(all[i]).position === 'fixed') return { el: all[i], host: host };
        }
      }
    }
    var frame = document.getElementById('dummy-chat-button-iframe') || document.querySelector('#shopify-chat > iframe:not([style*="min-height"])');
    return frame ? { el: frame, host: frame } : null;
  }
  function applyChatLift() {
    var t = chatTarget();
    if (!t) return;
    var open = t.host.getAttribute && (t.host.getAttribute('is-open') === 'true' || t.host.hasAttribute('opened'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.el.style.transition = reduce ? 'none' : 'translate 220ms cubic-bezier(0.2, 0, 0, 1)';
    if (!chatLift || open) { t.el.style.translate = ''; return; }
    if (!t.el.getBoundingClientRect().height) return;
    /* Its resting gap to the bottom of the screen (fixed: bottom offset plus bottom margin), so the sum
       does not depend on where an animation currently has it */
    var cs = getComputedStyle(t.el);
    var rest = (parseFloat(cs.bottom) || 0) + (parseFloat(cs.marginBottom) || 0);
    var need = chatLift + CHAT_GAP - rest;
    t.el.style.translate = need > 0 ? '0 ' + (-Math.ceil(need)) + 'px' : '';
  }
  function setChatLift(px) {
    chatLift = px;
    applyChatLift();
  }
  /* Diagnostics: add ?gg_debug=chat to a product page address to see what the lift found and did */
  if (/[?&]gg_debug=chat/.test(location.search)) {
    onReady(function () {
      var badge = document.createElement('div');
      badge.style.cssText = 'position:fixed;top:8px;left:8px;right:8px;z-index:2147483647;background:#151412;color:#fff;font:12px/1.4 monospace;padding:8px;white-space:pre-wrap;pointer-events:none';
      document.body.appendChild(badge);
      setInterval(function () {
        var host = document.querySelector('inbox-online-store-chat, #ShopifyChat');
        var t = chatTarget();
        var cs = t ? getComputedStyle(t.el) : null;
        badge.textContent = 'chat host: ' + (host ? host.tagName.toLowerCase() + '#' + host.id + ' pos=' + getComputedStyle(host).position + ' shadow=' + (host.shadowRoot ? 'open' : 'none/closed') : 'not found') +
          '\ntarget: ' + (t ? (t.el === t.host ? 'host' : t.el.tagName.toLowerCase() + '.' + (t.el.className || '')) + ' pos=' + cs.position + ' bottom=' + cs.bottom + ' translate=' + (t.el.style.translate || 'none') : 'none') +
          '\nbar lift: ' + chatLift + 'px   iframes: ' + document.querySelectorAll('iframe').length;
      }, 1000);
    });
  }

  /* Inbox loads after the page, and re-renders when opened or closed */
  onReady(function () {
    var tries = 0;
    var timer = setInterval(function () { tries++; if (chatTarget() || tries > 40) { clearInterval(timer); applyChatLift(); } }, 500);
    if (window.MutationObserver) {
      new MutationObserver(function () { if (chatLift) requestAnimationFrame(applyChatLift); })
        .observe(document.body, { childList: true, attributes: true, attributeFilter: ['is-open'], subtree: true });
    }
    window.addEventListener('resize', function () { if (chatLift) applyChatLift(); });
  });

  /* ---------- Sticky add to bag ---------- */
  if (!customElements.get('gg-sticky-atc')) {
    customElements.define('gg-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        /* Live directly in <body>: Spotlight's reveal-on-scroll animation leaves a transform on the product
           column, and a fixed bar inside a transformed parent stops being fixed to the screen (it stuck
           mid-page on iPhone). Moving it reconnects the element, and setup then runs once, here. */
        if (this.parentElement !== document.body) { document.body.appendChild(this); return; }
        if (this.ggReady) return;
        this.ggReady = true;
        var self = this;
        if (window.MutationObserver) {
          new MutationObserver(function () { self.syncChat(); }).observe(this, { attributes: true, attributeFilter: ['class'] });
          new MutationObserver(function () { self.syncChat(); }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        }
        try { this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent); } catch (e) { this.variants = {}; }
        this.mainBtn = $('.product-form__submit');
        this.btn = this.querySelector('[data-sticky-add]');
        this.changeBtn = this.querySelector('[data-sticky-change]');
        this.dealEl = this.querySelector('[data-sticky-deal]');
        try { this.siblings = JSON.parse(this.querySelector('[data-sticky-siblings]').textContent); } catch (e) { this.siblings = {}; }
        this.freeAt = +this.dataset.freeShipping || 0;
        this.set = this.dataset.set || 'other';
        this.setName = SET_NAMES[this.set] || '';
        /* Step aside while Complete the look is on screen: it has its own Add button, and the bar would
           otherwise sit over that button or its size pickers, so a tap meant for the look added only this item */
        var lookBox = $('gg-complete-look');
        if (lookBox && window.IntersectionObserver) {
          new IntersectionObserver(function (entries) {
            self.lookInView = entries[0].isIntersecting;
            self.classList.toggle('is-tucked-look', self.lookInView);
          }).observe(lookBox);
        }
        /* Step aside while Spotlight's added to bag pop-up is open */
        var pop = document.getElementById('cart-notification');
        if (pop && window.MutationObserver) {
          new MutationObserver(function () { self.classList.toggle('is-tucked', pop.classList.contains('active')); })
            .observe(pop, { attributes: true, attributeFilter: ['class'] });
        }
        var look = $('gg-complete-look');
        this.pct2 = look ? +look.dataset.pct2 || 10 : 10;
        this.pct3 = look ? +look.dataset.pct3 || 15 : 15;
        if (!this.mainBtn) return;
        this.mode = 'add';
        this.btn.addEventListener('click', function () {
          if (self.btn.disabled || self.busy) return;
          if (self.mode === 'look') { location.href = ROOT + '/cart'; return; }
          if (self.mode === 'notify') { self.openNotify(); return; }
          if (needSize()) { openAddSheet(); return; }
          self.busy = true;
          self.error = '';
          self.setLabel('Adding…');
          self.mainBtn.click();
          /* If nothing comes back (the main form blocked it), let the shopper try again */
          clearTimeout(self.busyTimer);
          self.busyTimer = setTimeout(function () { if (self.busy) { self.busy = false; self.update(); } }, 8000);
        });
        if (this.changeBtn) this.changeBtn.addEventListener('click', function () {
          if ((self.lines || []).length > 1) { location.href = ROOT + '/cart'; return; }
          self.changeSize();
        });
        /* Show once the main Add to bag button has scrolled above the screen. Checked on scroll (once per
           frame) rather than only when the button crosses the edge, so a fast fling past it still counts. */
        var queued = false;
        var check = function () {
          queued = false;
          var r = self.mainBtn.getBoundingClientRect();
          var show = r.bottom < 0;
          if (show !== self.classList.contains('is-visible')) self.toggle(show);
        };
        var queue = function () { if (!queued) { queued = true; requestAnimationFrame(check); } };
        window.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue);
        check();
        onVariantChange(function (variant) { self.selected = String(variant ? variant.id : currentVariantId()); self.error = ''; self.update(); });
        subscribeTo('cartUpdate', function (e) {
          if (self.busy) self.justAdded = true;
          self.busy = false;
          self.syncCart();
        });
        subscribeTo('cartError', function (e) {
          if (!self.busy) return;
          self.busy = false;
          self.error = (e && (e.message || (e.errors && (e.errors.description || e.errors)))) || 'Could not add to your bag. Please try again.';
          if (typeof self.error !== 'string') self.error = 'Could not add to your bag. Please try again.';
          self.update();
          clearTimeout(self.errorTimer);
          self.errorTimer = setTimeout(function () { self.error = ''; self.update(); }, 6000);
        });
        document.addEventListener('gg:cart-changed', function () { self.syncCart(); });
        /* The bag may have changed in another tab */
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') self.syncCart(); });
        window.addEventListener('pageshow', function (e) { if (e.persisted) self.syncCart(); });
        this.selected = String(currentVariantId());
        this.syncCart();
      }
      /* On screen = shown and not stepped aside (pop-up, sheet or Complete the look in view) */
      syncChat() {
        var on = this.classList.contains('is-visible') && !this.classList.contains('is-tucked') && !this.classList.contains('is-tucked-look') && !document.documentElement.classList.contains('gg-sheet-open');
        var h = on ? this.offsetHeight : 0;
        if (h !== this.chatH) { this.chatH = h; setChatLift(h); }
      }
      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', this).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        if (show) this.measure();
        document.body.classList.toggle('gg-sticky-on', show);
      }
      measure() {
        if (this.classList.contains('is-visible')) document.documentElement.style.setProperty('--gg-sticky-h', this.querySelector('.gg-sticky__inner').offsetHeight + 'px');
      }
      setLabel(text) { this.querySelector('[data-sticky-label]').textContent = text; }
      openNotify() {
        var box = $('gg-notify');
        if (!box) return;
        var details = box.querySelector('details');
        if (details) details.open = true;
        box.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        var input = box.querySelector('input[type="email"]');
        if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
      }
      syncCart() {
        var self = this;
        getCart().then(function (cart) {
          var ids = Object.keys(self.variants);
          self.lines = cart.items.filter(function (l) { return ids.indexOf(String(l.variant_id)) > -1; });
          /* Only pieces from this item's set count towards its 2 or 3 piece offer */
          self.bagCount = SET_NAMES[self.set] ? cart.items.reduce(function (n, l) { return setOf(l.product_title) === self.set ? n + l.quantity : n; }, 0) : 0;
          self.bagTotal = cart.total_price || 0;
          self.siblingLines = cart.items.filter(function (l) { return self.siblings[String(l.variant_id)]; });
          var look = null;
          try { look = JSON.parse(sessionStorage.getItem(LOOK_KEY)); } catch (e) {}
          var inCart = cart.items.map(function (l) { return l.variant_id; });
          /* Only show the look as applied on a page for one of its pieces (not, say, another colour of the top) */
          var mine = look && look.ids && look.ids.some(function (id) { return self.variants[String(id)]; });
          self.look = mine && look.ids.every(function (id) { return inCart.indexOf(id) > -1; }) ? look : null;
          self.update();
        }).catch(function () {});
      }
      /* What the set offer means for the shopper right now: 2 pieces from this item's set 10% off each,
         3 or more 15% off each. Items outside a set get no prompt. */
      dealText() {
        if (!this.setName) return '';
        var n = this.bagCount || 0;
        var set = this.setName;
        if (this.mode === 'add' || this.mode === 'notify' || this.mode === 'gone') {
          if (this.mode !== 'add' || n === 0) return '';
          if (n === 1) return 'Save ' + this.pct2 + '% on both ' + set + ' pieces';
          if (n === 2) return 'Save ' + this.pct3 + '% on all 3 ' + set + ' pieces';
          return 'Add this and save ' + this.pct3 + '% on it too';
        }
        if (this.mode === 'look' || n === 0) return '';
        if (n === 1) return 'Add 1 more ' + set + ' piece and save ' + this.pct2 + '% on each';
        if (n === 2) return 'Add a 3rd ' + set + ' piece and save ' + this.pct3 + '% on each';
        return this.pct3 + '% off each ' + set + ' piece in your bag';
      }
      freeText() {
        if (!this.freeAt || !this.bagTotal) return '';
        if (this.bagTotal >= this.freeAt) return 'Free shipping unlocked';
        return money(this.freeAt - this.bagTotal) + ' from free shipping';
      }
      update() {
        var v = this.variants[this.selected] || this.variants[String(currentVariantId())];
        var noSize = needSize();
        var meta = this.querySelector('[data-sticky-meta]');
        var lines = this.lines || [];
        var variants = this.variants;
        var available = !!(v && v.available);
        var label;
        if (this.look) {
          this.mode = 'look';
          meta.innerHTML = '<span class="gg-sticky__tick">' + this.look.n + ' piece look in your bag</span><span class="gg-sticky__dot" aria-hidden="true">·</span><span class="gg-sticky__save">' + this.look.pct + '% off each</span>';
          label = 'View bag';
        } else if (noSize && !lines.length) {
          /* Nothing picked yet: Add to bag asks for a size */
          this.mode = 'add';
          var anyV = this.variants[Object.keys(this.variants)[0]];
          meta.innerHTML = '<span data-sticky-price>' + (anyV ? esc(anyV.price) : '') + '</span><span class="gg-sticky__dot" aria-hidden="true">·</span><span data-sticky-size>Select size</span>';
          label = 'Add to bag';
        } else if (!available && v && isRetiredSize(v.size)) {
          this.mode = 'gone';
          meta.innerHTML = '<span class="gg-sticky__soldout">' + esc(v.size) + ' is sold out</span>';
          label = 'Sold out';
        } else if (!available) {
          /* The chosen size is sold out: offer the restock alert instead of a dead button */
          this.mode = 'notify';
          meta.innerHTML = '<span class="gg-sticky__soldout">' + (v ? esc(v.size) + ' is sold out' : 'Sold out') + '</span>';
          label = 'Notify me';
        } else if (lines.length) {
          this.mode = 'more';
          var inBag = lines.map(function (l) { var x = variants[String(l.variant_id)]; return (x ? x.size : '') + (l.quantity > 1 ? ' × ' + l.quantity : ''); }).join(', ');
          meta.innerHTML = '<span class="gg-sticky__tick">In your bag: ' + esc(inBag) + '</span>';
          label = 'Add another';
        } else {
          this.mode = 'add';
          meta.innerHTML = '<span data-sticky-price>' + (v ? esc(v.price) : '') + '</span><span class="gg-sticky__dot" aria-hidden="true">·</span><span data-sticky-size>' + (v ? esc(v.size) : '') + '</span>';
          label = 'Add to bag';
        }
        if (this.error) meta.innerHTML = '<span class="gg-sticky__error">' + esc(this.error) + '</span>';
        this.btn.disabled = this.mode === 'gone';
        this.btn.classList.toggle('button--secondary', this.mode === 'notify');
        this.btn.classList.toggle('button--primary', this.mode !== 'notify');
        var self = this;
        if (this.justAdded) {
          this.justAdded = false;
          this.setLabel('Added');
          this.btn.classList.add('is-added');
          clearTimeout(this.addedTimer);
          this.addedTimer = setTimeout(function () { self.btn.classList.remove('is-added'); self.setLabel(label); }, 1600);
        } else if (!this.btn.classList.contains('is-added')) {
          this.setLabel(this.busy ? 'Adding…' : label);
        }
        if (this.changeBtn) {
          this.changeBtn.hidden = this.mode !== 'more';
          this.changeBtn.textContent = lines.length > 1 ? 'Edit bag' : 'Change size';
        }
        /* Second line: up to two short notes, most useful first (one when the bar is a single row) */
        var notes = [];
        var sibs = this.siblings;
        var others = (this.siblingLines || []).map(function (l) { var x = sibs[String(l.variant_id)]; return x.colour + ' (' + x.size + ')'; });
        if (others.length && this.mode !== 'look') notes.push(others.join(', ') + ' in your bag');
        var deal = this.dealText();
        if (deal) notes.push(deal);
        var free = this.mode === 'notify' || this.mode === 'gone' ? '' : this.freeText();
        if (free) notes.push(free);
        notes = notes.slice(0, this.mode === 'more' || this.mode === 'look' ? 2 : 1);
        if (this.dealEl) { this.dealEl.textContent = notes.join(' · '); this.dealEl.hidden = !notes.length || !!this.error; }
        this.classList.toggle('has-change', !!(this.changeBtn && !this.changeBtn.hidden));
        this.classList.toggle('is-stacked', this.mode === 'more' || this.mode === 'look');
        this.measure();
      }
      /* Change size of what's already in the bag: swap the line for the chosen size, same quantity */
      changeSize() {
        var self = this;
        var line = (this.lines || [])[0];
        var list = Object.keys(this.variants).map(function (id) { var x = self.variants[id]; return { id: id, size: x.size, available: x.available }; });
        var chart = $('template[data-main-chart]');
        openSizeSheet({
          title: 'Change size',
          variants: list,
          selected: line ? line.variant_id : this.selected,
          chart: chart ? chart.innerHTML : '',
          onSelect: function (id) {
            var v = self.variants[String(id)];
            if (v) chooseMainSize(v.size);
            if (!line || String(line.variant_id) === String(id)) return;
            var qty = line.quantity;
            fetch(ROOT + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
              .then(function () {
                return fetch(ROOT + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }], sections: 'cart-icon-bubble' }) });
              })
              .then(function (r) { return r.json(); })
              .then(function (res) { if (res.sections) refreshBubble(res.sections['cart-icon-bubble']); cartChanged('gg-sticky-change-size'); });
          }
        });
      }
    });
  }

  /* ---------- Discount codes in the bag ----------
     Every request has a time limit, and the result is always written to whichever discount box is on the page
     when the request finishes (the bag re-renders, so the box that started the request may have been replaced).
     If the bag cannot be re-rendered in place, the page reloads and the result is shown after the reload. */
  var codesMessage = '';
  var CODES_MSG_KEY = 'gg-codes-msg';
  function codesSay(text) {
    codesMessage = text;
    $$('gg-discount-codes [data-codes-msg]').forEach(function (m) { m.textContent = text; });
  }
  function codesReload(text) {
    try { sessionStorage.setItem(CODES_MSG_KEY, text); } catch (e) {}
    location.reload();
  }
  function timedFetch(url, opts, ms) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || 15000) : null;
    if (ctrl) opts = Object.assign({}, opts || {}, { signal: ctrl.signal });
    return fetch(url, opts).then(function (r) { clearTimeout(timer); return r; }, function (e) { clearTimeout(timer); throw e; });
  }
  function codeMatch(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }
  /* Bring a lifter codes (FIRSTNAME-XXXX). The bag keeps the code as the cart attribute herd_ref, so the referral
     reward Flow still credits the member when a Complete the look offer saves the mate more and the code is not applied. */
  var REF_CODE = /^[A-Za-z]{2,10}-[0-9A-Za-z]{4}$/;
  function isRef(code) { return REF_CODE.test(String(code || '').trim()); }
  /* Athlete codes (shop metafield custom.gg_athlete_codes, printed in the discount box as JSON): kept on the bag as
     the cart attribute athlete_code, so a Flow can flag the order for commission when Complete the look wins. */
  function athletes() {
    var el = document.querySelector('[data-athlete-codes]');
    try { return (el && JSON.parse(el.textContent)) || {}; } catch (e) { return {}; }
  }
  function isAthlete(code) { return Object.prototype.hasOwnProperty.call(athletes(), String(code || '').trim().toUpperCase()); }
  /* The cart attribute that remembers this code, or null for an ordinary code */
  function codeAttr(code, value) {
    if (isRef(code)) return { herd_ref: value };
    if (isAthlete(code)) return { athlete_code: value };
    return null;
  }
  /* On every page: if a referral or athlete code is on the bag (a /discount/ link or a typed code), save it as
     its cart attribute, so it reaches the order even when the shopper checks out from the drawer and
     Complete the look ends up beating the code. */
  function rememberCodes() {
    getCart().then(function (cart) {
      var attrs = cart.attributes || {};
      var want = {};
      (cart.discount_codes || []).forEach(function (c) {
        var a = codeAttr(c.code, String(c.code).trim().toUpperCase());
        if (!a) return;
        var k = Object.keys(a)[0];
        if (!want[k] && !codeMatch(attrs[k] || '', a[k])) want[k] = a[k];
      });
      if (!Object.keys(want).length) return;
      return fetch(ROOT + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: want }) });
    }).catch(function () {});
  }
  onReady(rememberCodes);
  function keptMessage(code) {
    var c = String(code).toUpperCase();
    if (isRef(c)) return 'Complete the look already saves you more than ' + c + ', so you get that instead. It still counts: your mate gets their reward when you order.';
    var name = athletes()[c];
    return 'Complete the look already saves you more than ' + c + ', so you get that instead. ' + (name ? name + ' still gets credit' : 'The athlete who shared it still gets credit') + ' for sending you.';
  }
  function hasAutomatic(cart) {
    var auto = function (a) { return a && a.discount_application && a.discount_application.type === 'automatic'; };
    if ((cart.cart_level_discount_applications || []).some(function (d) { return d.type === 'automatic'; })) return true;
    return (cart.items || []).some(function (i) { return (i.line_level_discount_allocations || []).some(auto); });
  }
  /* The biggest Complete the look (automatic) percentage on the bag, e.g. 10 or 15; 0 when there is none */
  function autoPercent(cart) {
    var best = 0;
    var take = function (d) {
      if (!d || d.type !== 'automatic' || d.value_type !== 'percentage') return;
      var v = parseFloat(d.value);
      if (v > best) best = v;
    };
    (cart.cart_level_discount_applications || []).forEach(take);
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) { take(a.discount_application); });
    });
    return Math.round(best);
  }
  /* Why a code on the bag is not taking anything off, in plain words. Shoppers always ask why. */
  function whyNot(code, el) {
    var c = String(code).toUpperCase();
    var guest = el.dataset.guest === '1';
    var orders = parseInt(el.dataset.orders || '0', 10);
    var pct = el.autoPct || 0;
    if (c === 'WELCOME10') {
      if (orders > 0) return 'WELCOME10 is for a first order, and you\'ve ordered with us before, so it can\'t be used on this bag.';
      if (el.auto) {
        if (pct > 10) return 'Complete the look already takes ' + pct + '% off, more than WELCOME10\'s 10%. The two don\'t add together, so you get the bigger ' + pct + '% saving.';
        return 'Complete the look already takes 10% off, the same as WELCOME10. The two don\'t add together, so you get the Complete the look saving instead.';
      }
      if (guest) return 'Your 10% comes off at checkout once you enter the email you joined with.';
      return '';
    }
    if (el.auto && !codeAttr(c, '')) {
      return 'Complete the look already takes ' + (pct ? pct + '% ' : '') + 'off, and ' + c + ' can\'t be added on top, so you get the Complete the look saving instead.';
    }
    return '';
  }
  if (!customElements.get('gg-discount-codes')) {
    customElements.define('gg-discount-codes', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.form = $('[data-codes-form]', this);
        this.input = $('[data-codes-input]', this);
        this.list = $('[data-codes-list]', this);
        this.msg = $('[data-codes-msg]', this);
        this.codes = $$('[data-remove-code]', this).map(function (b) { return { code: b.dataset.removeCode, applicable: true }; });
        var saved = '';
        try { saved = sessionStorage.getItem(CODES_MSG_KEY) || ''; sessionStorage.removeItem(CODES_MSG_KEY); } catch (e) {}
        if (codesMessage || saved) this.msg.textContent = codesMessage || saved;
        if (document.documentElement.classList.contains('gg-codes-busy')) this.busy(true);
        this.form.addEventListener('submit', function (e) { e.preventDefault(); self.apply(self.input.value); });
        /* Birthday one-tap code (gg-discount-codes): add it like a typed code, then hide the button */
        this.addEventListener('click', function (e) {
          var q = e.target.closest('[data-codes-quick]');
          if (!q) return;
          q.hidden = true;
          self.apply(q.dataset.codesQuick);
        });
        this.list.addEventListener('click', function (e) {
          var b = e.target.closest('[data-remove-code]');
          if (b) self.remove(b.dataset.removeCode);
        });
        getCart().then(function (cart) {
          self.auto = hasAutomatic(cart);
          self.autoPct = autoPercent(cart);
          if (cart.discount_codes) { self.codes = cart.discount_codes; self.draw(); }
          /* A referral or athlete code reached the bag another way (a typed code, a /discount link): remember it too */
          var attrs = cart.attributes || {};
          var want = {};
          (cart.discount_codes || []).forEach(function (c) {
            var a = codeAttr(c.code, c.code.toUpperCase());
            if (!a) return;
            var k = Object.keys(a)[0];
            if (!codeMatch(attrs[k] || '', a[k])) want[k] = a[k];
          });
          if (Object.keys(want).length) {
            self.send(null, want).then(function () { return self.refresh(codesMessage); }).catch(function () {});
          }
        }).catch(function () {});
      }
      draw() {
        var self = this;
        var closeIcon = (this.list.querySelector('.gg-codes__remove') || {}).innerHTML || '×';
        var t = document.querySelector('[data-gg-icon-close]');
        if (t) closeIcon = t.innerHTML;
        var whyBox = this.querySelector('[data-codes-why]');
        if (!whyBox) {
          whyBox = document.createElement('div');
          whyBox.className = 'gg-codes__why';
          whyBox.setAttribute('data-codes-why', '');
          this.list.insertAdjacentElement('afterend', whyBox);
        }
        whyBox.innerHTML = this.codes.map(function (c) {
          var w = '';
          if (!c.applicable) w = whyNot(c.code, self);
          /* Birthday code wins over Complete the look: say so, so a missing set saving is not a surprise */
          else if (/^TWOYEARS$/i.test(c.code)) w = 'TWOYEARS takes 20% off your whole bag. It doesn\'t add on top of Complete the look, so where both could apply you get the bigger 20%.';
          return w ? '<p>' + esc(w) + '</p>' : '';
        }).join('');
        this.list.innerHTML = this.codes.map(function (c) {
          var welcomeLater = /^WELCOME10$/i.test(c.code) && self.dataset.guest === '1' && !self.auto;
          var state = codeAttr(c.code, '') && self.auto ? 'Bigger saving on' : (welcomeLater ? 'At checkout' : 'Not applied');
          return '<li class="gg-codes__chip' + (c.applicable ? '' : ' is-inactive') + '"><span class="gg-codes__code">' + esc(c.code) + '</span>' +
            (c.applicable ? '' : '<span class="gg-codes__state">' + state + '</span>') +
            '<button type="button" class="gg-codes__remove" data-remove-code="' + esc(c.code) + '" aria-label="Remove discount code ' + esc(c.code) + '">' + closeIcon + '</button></li>';
        }).join('');
      }
      send(codes, attributes) {
        var body = {};
        if (codes) body.discount = codes.join(',');
        if (attributes) body.attributes = attributes;
        return timedFetch(ROOT + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
      }
      /* The codes Shopify now holds on the bag. Read again from /cart.js if the update reply does not list the new code yet. */
      codesAfter(cart, code) {
        var list = cart.discount_codes || [];
        if (list.some(function (c) { return codeMatch(c.code, code); })) return Promise.resolve(list);
        return timedFetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (c) { return c.discount_codes || []; });
      }
      /* Busy state is kept on <html> too, so a box re-rendered mid-request stays busy until the request ends */
      busy(on) {
        document.documentElement.classList.toggle('gg-codes-busy', on);
        $$('gg-discount-codes').forEach(function (el) {
          var b = $('[data-codes-apply]', el);
          if (b) b.disabled = on;
          el.classList.toggle('is-busy', on);
        });
      }
      apply(raw) {
        var self = this;
        var code = String(raw || '').trim();
        if (!code) { codesSay('Enter a discount code.'); this.input.focus(); return; }
        var current = this.codes.map(function (c) { return c.code; });
        if (current.some(function (c) { return codeMatch(c, code); })) { codesSay(code.toUpperCase() + ' is already on your bag.'); return; }
        var shown = code.toUpperCase();
        this.busy(true);
        codesSay('Checking ' + shown + '…');
        var result = '';
        var refAttr = codeAttr(code, shown);
        var autoNow = false;
        this.send(current.concat(code), refAttr)
          .then(function (cart) { autoNow = hasAutomatic(cart); self.auto = autoNow; self.autoPct = autoPercent(cart); return self.codesAfter(cart, code); })
          .then(function (list) {
            var mine = list.filter(function (c) { return codeMatch(c.code, code); })[0];
            /* WELCOME10 for a signed-out shopper: Shopify only checks it is a first order once checkout has their email, so keep it */
            if (mine && !mine.applicable && /^WELCOME10$/i.test(code) && parseInt(self.dataset.orders || '0', 10) === 0 && (self.dataset.guest === '1' || autoNow)) {
              /* Kept on the bag: it comes off at checkout, or as soon as Complete the look no longer wins */
              result = autoNow ? 'WELCOME10 is saved on your bag.' : 'WELCOME10 is on. Your 10% comes off at checkout once you enter the email you joined with.';
              return null;
            }
            if (mine && !mine.applicable && /^WELCOME10$/i.test(code)) {
              result = whyNot('WELCOME10', self) || (shown + ' cannot be used on this bag.');
              return self.send(current, codeAttr(code, ''));
            }
            /* A referral or athlete code that loses to a bigger automatic saving stays on the bag: it still counts for them */
            if (mine && !mine.applicable && refAttr && autoNow) {
              result = keptMessage(mine.code);
              return null;
            }
            if (mine && mine.applicable) {
              /* Codes that stopped applying because they do not combine with the new one are taken off */
              var dropped = list.filter(function (c) { return !c.applicable && !codeMatch(c.code, code); }).map(function (c) { return c.code; });
              result = mine.code + ' applied.';
              if (dropped.length) {
                result += ' It cannot be combined with ' + dropped.join(' or ') + ', so ' + (dropped.length > 1 ? 'those codes have' : 'that code has') + ' been taken off.';
                var keep = list.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
                return self.send(keep);
              }
              return null;
            }
            /* Not usable on this bag: take it off again so the bag is as it was */
            result = current.length
              ? shown + ' cannot be used with the code already on your bag. To use ' + shown + ' instead, remove ' + current.join(', ') + ' first.'
              : shown + ' cannot be used on this bag. Check the code is typed correctly and has not expired or already been used.';
            return self.send(current, codeAttr(code, ''));
          })
          .then(function () { return self.refresh(result); })
          .catch(function () {
            /* Something did not answer in time: reload so the bag shows exactly what Shopify holds */
            codesReload(result || 'Please check the codes on your bag below.');
          })
          .then(function () { self.busy(false); codesSay(result || codesMessage); codesMessage = ''; });
      }
      remove(code) {
        var self = this;
        var rest = this.codes.map(function (c) { return c.code; }).filter(function (c) { return c !== code; });
        var result = code + ' removed.';
        this.busy(true);
        codesSay('Removing ' + code + '…');
        this.send(rest, codeAttr(code, ''))
          .then(function () { return self.refresh(result); })
          .catch(function () { codesReload(result); })
          .then(function () { self.busy(false); codesSay(result); codesMessage = ''; });
      }
      /* Re-render the bag's lines and totals so discounted prices show straight away */
      refresh(text) {
        codesMessage = text || '';
        var items = document.getElementById('main-cart-items');
        var footer = document.getElementById('main-cart-footer');
        var ids = [items && items.dataset.id, footer && footer.dataset.id].filter(Boolean);
        if (!ids.length) return Promise.reject(new Error('no bag sections'));
        return timedFetch(ROOT + '/cart?sections=' + ids.join(','), { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
          .then(function (sections) {
            var swapped = 0;
            [items, footer].forEach(function (wrap) {
              if (!wrap || !sections[wrap.dataset.id]) return;
              var html = new DOMParser().parseFromString(sections[wrap.dataset.id], 'text/html');
              /* Swap each .js-contents block in order, so the block holding the discount box is the one replaced */
              var fresh = $$('#' + wrap.id + ' .js-contents', html);
              if (!fresh.length) fresh = $$('.js-contents', html);
              $$('.js-contents', wrap).forEach(function (target, i) {
                if (fresh[i]) { target.innerHTML = fresh[i].innerHTML; swapped++; }
              });
            });
            if (!swapped) throw new Error('nothing swapped');
            try { cartChanged('gg-discount-codes'); } catch (e) {}
          });
      }
    });
  }

  /* ---------- Filter sidebar: Sort by list and colour squares ----------
     Sort by (gg-facet-sort) is a list of radios outside Spotlight's filter form. Choosing one sets Spotlight's
     own #SortBy select and fires its input event, so the grid updates through facets.js as normal.
     Colour squares: gg-facet-sort lists, for each colour value, an image of a product in that colour.
     The image is drawn small and the most common colour in the lower body of the garment (below any chest
     print, ignoring the light background) becomes the square. Results are kept on this device. Until an image
     has been read, or if it cannot be, the square uses a colour picked from the name. */
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-gg-sort]');
    if (!r) return;
    var sel = document.getElementById('SortBy');
    if (!sel) return;
    sel.value = r.value;
    sel.dispatchEvent(new Event('input', { bubbles: true }));
  });

  var SWATCH_KEY = 'gg-swatch-v1';
  var swatchCache = {};
  try { swatchCache = JSON.parse(localStorage.getItem(SWATCH_KEY) || '{}') || {}; } catch (e) { swatchCache = {}; }
  var NAMED = [
    ['black', '#1D1C1A'], ['white', '#F4F2EE'], ['navy', '#232B3D'], ['royal', '#2F4A8A'], ['dark blue', '#2A3446'],
    ['blue', '#3A5A8C'], ['dark green', '#2F3A2E'], ['green', '#4C5A43'], ['light gr', '#C4C1BB'], ['dark gr', '#4A4A49'],
    ['pirate', '#56575B'], ['flower', '#9C9A96'], ['fleck', '#8E8D8A'], ['gr', '#8B8A87'], ['pink', '#C98A9A'],
    ['red', '#8A2E2E'], ['brown', '#5A3E2E'], ['beige', '#D6CBB8'], ['cream', '#EDE6D6'], ['purple', '#5E4A73'], ['yellow', '#E3C84B']
  ];
  function namedColour(name) {
    var n = String(name).toLowerCase();
    for (var i = 0; i < NAMED.length; i++) if (n.indexOf(NAMED[i][0]) > -1) return NAMED[i][1];
    return '#E2DED7';
  }
  function hex(c) { return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }
  function sampleImage(url, cb) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var w = 40, h = 50, cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        var d = ctx.getImageData(Math.round(w * 0.3), Math.round(h * 0.56), Math.round(w * 0.4), Math.round(h * 0.26)).data;
        var buckets = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
          if (a < 200) continue;
          if (r > 236 && g > 236 && b > 236) continue; /* studio background */
          var k = (r >> 4) + ',' + (g >> 4) + ',' + (b >> 4);
          var bk = buckets[k] || (buckets[k] = { n: 0, r: 0, g: 0, b: 0 });
          bk.n++; bk.r += r; bk.g += g; bk.b += b;
        }
        var best = null;
        for (var key in buckets) if (!best || buckets[key].n > best.n) best = buckets[key];
        cb(best ? hex([best.r / best.n, best.g / best.n, best.b / best.n]) : null);
      } catch (err) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function colourSources() {
    var el = document.querySelector('[data-gg-colour-src]');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }
  function paintSwatches() {
    var groups = $$('details[id*="filter.v.option.colo"]');
    if (!groups.length) return;
    var src = colourSources();
    groups.forEach(function (g) {
      $$('.facet-checkbox__text', g).forEach(function (t) {
        var lab = t.querySelector('.facet-checkbox__text-label');
        var name = lab ? lab.textContent.trim() : '';
        if (!name) return;
        var sw = t.previousElementSibling && t.previousElementSibling.classList.contains('gg-swatch') ? t.previousElementSibling : null;
        if (!sw) {
          sw = document.createElement('span');
          sw.className = 'gg-swatch';
          sw.setAttribute('aria-hidden', 'true');
          t.parentNode.insertBefore(sw, t);
        }
        var url = src[name];
        var cached = url && swatchCache[name + '|' + url];
        sw.style.setProperty('--gg-swatch', cached || namedColour(name));
        if (url && !cached && !sw.dataset.sampling) {
          sw.dataset.sampling = '1';
          sampleImage(url, function (c) {
            if (!c) return;
            swatchCache[name + '|' + url] = c;
            try { localStorage.setItem(SWATCH_KEY, JSON.stringify(swatchCache)); } catch (e) {}
            $$('details[id*="filter.v.option.colo"] .facet-checkbox__text-label').forEach(function (l) {
              if (l.textContent.trim() === name) {
                var s = l.closest('.facet-checkbox__text').previousElementSibling;
                if (s && s.classList.contains('gg-swatch')) s.style.setProperty('--gg-swatch', c);
              }
            });
          });
        }
      });
    });
  }
  var swatchTimer;
  function queueSwatches() { clearTimeout(swatchTimer); swatchTimer = setTimeout(paintSwatches, 30); }
  onReady(function () {
    if (!document.querySelector('[data-gg-colour-src]')) return;
    paintSwatches();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest('.gg-swatch')) continue;
        if (muts[i].addedNodes.length) { queueSwatches(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });

  /* ---------- Recently viewed (gg-recently-viewed) ----------
     Kept on this device in localStorage "gg-recent" as [{h: handle, t: title}], newest first, up to 12.
     One entry per item: viewing another colour of the same item replaces the older colour.
     Cards come from /products/<handle>?section_id=gg-card-feed so they match every other card. */
  var RECENT_KEY = 'gg-recent';
  function readRecent() { try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeRecent(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {} }
  function noteRecent(handle, title) {
    if (!handle) return;
    var key = String(title || handle).trim().toLowerCase();
    var list = readRecent().filter(function (r) { return r.h !== handle && String(r.t || r.h).trim().toLowerCase() !== key; });
    list.unshift({ h: handle, t: title || '' });
    writeRecent(list);
  }
  function renderRecent(section) {
    var grid = section.querySelector('[data-gg-recent-grid]');
    if (!grid) return;
    var limit = +section.dataset.limit || 4;
    var current = section.dataset.current || '';
    var currentTitle = String(section.dataset.currentTitle || '').trim().toLowerCase();
    var list = readRecent().filter(function (r) { return r.h !== current && !(currentTitle && String(r.t || '').trim().toLowerCase() === currentTitle); }).slice(0, limit);
    if (!list.length) { section.hidden = true; return; }
    Promise.all(list.map(function (r) {
      return fetch(ROOT + '/products/' + encodeURIComponent(r.h) + '?section_id=gg-card-feed')
        .then(function (res) { return res.ok ? res.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var cards = [];
      htmls.forEach(function (html, i) {
        if (!html) {
          /* gone or unpublished: drop it from the list */
          writeRecent(readRecent().filter(function (r) { return r.h !== list[i].h; }));
          return;
        }
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var card = holder.querySelector('.gg-card-wrap');
        if (card) cards.push(card);
      });
      grid.innerHTML = '';
      cards.forEach(function (c) { grid.appendChild(c); });
      section.hidden = cards.length === 0;
      syncHearts();
    });
  }
  onReady(function () {
    $$('[data-gg-recent]').forEach(function (section) {
      renderRecent(section);
      if (section.dataset.current) noteRecent(section.dataset.current, section.dataset.currentTitle);
    });
  });

  /* ---------- Infinite loading on product grids (gg-load-more) ----------
     When the block nears the screen, fetch the next page of the same section and append its products.
     Filters and sorting re-render the grid (facets.js), which brings a fresh block; the observer below
     picks that up too. Each block loads one page at a time. */
  var infiniteIO = null;
  function loadNextPage(block) {
    var next = block.dataset.next;
    if (!next || block.dataset.loading === '1') return;
    block.dataset.loading = '1';
    block.classList.add('is-loading');
    var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(block.dataset.section);
    fetch(url).then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.getElementById('product-grid');
      var items = doc.querySelectorAll('#product-grid > .grid__item');
      if (grid && items.length) {
        var frag = document.createDocumentFragment();
        items.forEach(function (li) {
          /* reveal animations only start on page load, so new cards would stay hidden: show them as they are */
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in'); });
          frag.appendChild(document.importNode(li, true));
        });
        grid.appendChild(frag);
      }
      var fresh = doc.querySelector('[data-gg-infinite]');
      var shown = grid ? grid.querySelectorAll(':scope > .grid__item').length : 0;
      var total = +block.dataset.total || shown;
      var count = block.querySelector('[data-gg-shown]');
      if (count) count.textContent = Math.min(shown, total);
      var bar = block.querySelector('[data-gg-infinite-bar]');
      if (bar && total) bar.style.width = Math.round(Math.min(shown, total) / total * 100) + '%';
      var btn = block.querySelector('[data-gg-infinite-btn]');
      if (fresh && fresh.dataset.next) {
        block.dataset.next = fresh.dataset.next;
        if (btn) btn.href = fresh.dataset.next;
      } else {
        delete block.dataset.next;
        if (btn) btn.remove();
        if (infiniteIO) infiniteIO.unobserve(block);
      }
      syncHearts();
    }).catch(function () {
      /* leave the Load more link in place so the next page is still one tap away */
    }).then(function () {
      block.dataset.loading = '';
      block.classList.remove('is-loading');
      /* if the block is still on screen (short pages, fast scrolling), keep going */
      if (block.dataset.next) {
        var r = block.getBoundingClientRect();
        if (r.top < window.innerHeight + 600) loadNextPage(block);
      }
    });
  }
  function bindInfinite() {
    if (!('IntersectionObserver' in window)) return;
    if (!infiniteIO) {
      infiniteIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadNextPage(e.target); });
      }, { rootMargin: '0px 0px 600px 0px' });
    }
    $$('[data-gg-infinite]').forEach(function (block) {
      if (block.dataset.bound === '1') return;
      block.dataset.bound = '1';
      block.classList.add('is-auto');
      var btn = block.querySelector('[data-gg-infinite-btn]');
      if (btn) btn.addEventListener('click', function (ev) { ev.preventDefault(); loadNextPage(block); });
      if (block.dataset.next) infiniteIO.observe(block);
    });
  }
  onReady(function () {
    bindInfinite();
    var container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(bindInfinite).observe(container, { childList: true, subtree: false });
  });

  /* ---------- Swipeable card photos (gg-card-gallery) ----------
     Swiping is plain CSS scroll snap. Here: keep the line at the bottom in step with the photo showing, and run
     the desktop arrows. Delegated from the document, so cards added later (infinite loading, recently viewed,
     best sellers) work without setting anything up. */
  function cgIndex(track) { var w = track.clientWidth || 1; return Math.round(track.scrollLeft / w); }
  function cgSync(gallery) {
    var track = gallery.querySelector('[data-gg-cg-track]');
    if (!track) return;
    var n = track.children.length;
    var i = Math.max(0, Math.min(n - 1, cgIndex(track)));
    gallery.querySelectorAll('.gg-cg__dots span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    var prev = gallery.querySelector('[data-gg-cg-prev]');
    var next = gallery.querySelector('[data-gg-cg-next]');
    if (prev) prev.hidden = i === 0;
    if (next) next.hidden = i >= n - 1;
  }
  var cgRaf = null;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gg-cg-track]')) return;
    if (cgRaf) cancelAnimationFrame(cgRaf);
    cgRaf = requestAnimationFrame(function () { cgSync(t.closest('[data-gg-cg]')); });
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gg-cg-prev], [data-gg-cg-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var gallery = btn.closest('[data-gg-cg]');
    var track = gallery && gallery.querySelector('[data-gg-cg-track]');
    if (!track) return;
    var dir = btn.hasAttribute('data-gg-cg-next') ? 1 : -1;
    var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    track.scrollTo({ left: (cgIndex(track) + dir) * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  });

  /* ---------- Start ---------- */
  function start() { syncHearts(); renderSaved(); if (savedUnit()) setUnit(savedUnit()); }
  onReady(start);
  window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
})();

/* Judge.me: one short line under the review summary explaining what "Verified" means.
   The widget renders after page load, so wait for its first verified tag (the summary one). */
(function () {
  var NOTE = 'Verified means the review comes from a real customer who bought this product. We match every verified review to their order.';
  function addNote() {
    if (document.querySelector('.gg-jm-verified-note')) return true;
    var badge = document.querySelector(".jdgm-widget [class*='verified'][class*='badge']:not([class*='__'])");
    if (!badge || !badge.parentElement) return false;
    var p = document.createElement('p');
    p.className = 'gg-jm-verified-note';
    p.textContent = NOTE;
    badge.parentElement.insertAdjacentElement('afterend', p);
    /* Herd review XP prompt (snippets/gg-herd-review-xp.liquid), moved in under the note */
    var xp = document.querySelector('[data-gg-review-xp]');
    if (xp) { p.insertAdjacentElement('afterend', xp); xp.hidden = false; }
    return true;
  }
  function start() {
    if (!document.querySelector('.jdgm-widget') && !document.querySelector('[class*="jdgm"]')) return;
    if (addNote()) return;
    var obs = new MutationObserver(function () { if (addNote()) obs.disconnect(); });
    obs.observe(document.body, { childList: true, subtree: true });
    /* Products with no reviews yet have no verified tag: after a few seconds put the XP prompt at the top of the widget */
    setTimeout(function () {
      var xp = document.querySelector('[data-gg-review-xp][hidden]');
      var w = document.querySelector('.jdgm-widget');
      if (xp && w && !document.querySelector('.gg-jm-verified-note')) { w.insertAdjacentElement('afterbegin', xp); xp.hidden = false; }
    }, 4000);
    setTimeout(function () { obs.disconnect(); }, 20000);
  }
  /* "Write your review" opens Judge.me's own review form */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-gg-write-review]');
    if (!t) return;
    var w = document.querySelector('.jdgm-widget');
    var btn = null;
    if (w) Array.prototype.some.call(w.querySelectorAll('button, a, [role="button"]'), function (el) {
      if (/write a review/i.test(el.textContent || '')) { btn = el; return true; } return false;
    });
    if (btn) btn.click(); else if (w) w.scrollIntoView({ behavior: 'smooth' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* GYMGAUR 2nd birthday: copy the code on the Herd page (gg-birthday-herd) */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gg-bday-copy]');
    if (!b) return;
    var code = b.getAttribute('data-gg-bday-copy');
    var msg = document.querySelector('[data-gg-bday-msg]');
    var done = function () { b.textContent = 'Copied'; if (msg) msg.textContent = code + ' copied. Add it at checkout or in your bag.'; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { if (msg) msg.textContent = 'Copy the code: ' + code; });
    } else if (msg) { msg.textContent = 'Copy the code: ' + code; }
  });
})();

/* GYMGAUR 2nd birthday countdown (gg-herd-announce bar and gg-birthday-herd block). Counts to the end of the
   current phase set by gg-birthday-head: tease to Fri 00:00 BST, live to Sun 00:00 BST, last to Mon 00:00 GMT.
   When a real phase ends it reloads once so the next phase shows (not when a phase is forced with ?gg_bday=). */
(function () {
  var ENDS = { tease: 1792710000, live: 1792882800, last: 1792972800 };
  var forced = false;
  try { forced = !!sessionStorage.getItem('gg_bday'); } catch (e) {}
  var reloaded = false;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var end = ENDS[document.documentElement.getAttribute('data-gg-bday')];
    var bars = document.querySelectorAll('[data-gg-bday-timer]');
    var boxes = document.querySelectorAll('[data-gg-bday-count]');
    if (!end || (!bars.length && !boxes.length)) return false;
    var left = Math.max(0, Math.floor(end - Date.now() / 1000));
    var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    var text = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    Array.prototype.forEach.call(bars, function (b) { b.textContent = text; });
    Array.prototype.forEach.call(boxes, function (b) {
      var u = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
      Object.keys(u).forEach(function (k) { var el = b.querySelector('[data-u="' + k + '"]'); if (el) el.textContent = u[k]; });
    });
    if (left === 0 && !forced && !reloaded) { reloaded = true; setTimeout(function () { location.reload(); }, 1500); }
    return true;
  }
  function start() { if (tick()) setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
